import $ from 'jquery'

import ComponentFactory from 'scripts/component-factory'

import Block from '../../block'
import ShoppingcartProduct from '../shoppingcart-product'

export default class ShoppingcartProducts extends Block {
	static title = 'shoppingcart-products'

	constructor($el) {
		super($el)

		// the cart is rendered more than once (mobile, desktop, popup), every copy redraws itself
		$(document).on('product:add', (index, data) => this.render(data.html))
	}

	render(html) {
		if (!html) {
			return
		}

		this.$el.html(html)

		// lines drawn after page load are not picked up by the compiler
		this.$el.find(`.${ShoppingcartProduct.title}`).each(function () {
			ComponentFactory.create(ShoppingcartProduct, $(this), false)
		})
	}
}
